import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Backdrop, Form, FormCancelButton, FormSubmitButton, SelectField } from 'components';

import { EmailListItem } from '../EmailListItem';
import { USER_OPTIONS } from './constants';
import { useInviteEmployeesForm } from './hooks';
import { ButtonsW, FieldsW, FormW, ListW } from './styled';

interface InviteEmployeesFormProps {
  setFormHasContent: (value: boolean) => void;
}

export function InviteEmployeesForm({ setFormHasContent }: InviteEmployeesFormProps): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    handleSubmit,
    handleRemoveItem,
    inputRef,
    usersList,
    isLoading,
    isManager,
    handleUserItemOnChange,
    handleUserSetRole,
  } = useInviteEmployeesForm({ setFormHasContent });

  return (
    <>
      {isLoading && <Backdrop />}

      <Form
        onSubmit={handleSubmit}
        flexDirection="row"
        justifyContent="flex-start"
        alignItems="flex-end"
      >
        <FormW isManager={isManager}>
          <ListW>
            {usersList &&
              usersList.map(({ id, email, role }, index) => {
                return (
                  <FieldsW key={index} isManager={isManager}>
                    <EmailListItem
                      id={id}
                      role={role}
                      email={email}
                      handleRemove={handleRemoveItem}
                      handleOnChange={handleUserItemOnChange}
                      inputRef={index === usersList.length - 1 ? inputRef : null}
                    />
                    {isManager ? (
                      <div style={{ width: '200px' }}>
                        <SelectField
                          key={role}
                          id={id}
                          options={USER_OPTIONS}
                          defaultValue={role || USER_OPTIONS[0].value}
                          name={email}
                          onChange={handleUserSetRole}
                          inputSx={{
                            height: '58px',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            '& .MuiSelect-select.MuiSelect-select': {
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: '14px',
                              '&:focus': { background: 'none' },
                            },
                            '& .MuiSelect-icon': { fontSize: '20px' },
                          }}
                        />
                      </div>
                    ) : null}
                  </FieldsW>
                );
              })}
          </ListW>
          <ButtonsW>
            <FormCancelButton
              variant="outlined"
              onClick={() => navigate(-1)}
              className="fixed-bottom"
            >
              {t('common.cancel')}
            </FormCancelButton>
            <FormSubmitButton type="submit" disabled={isLoading} className="fixed-bottom">
              {t('common.create')}
            </FormSubmitButton>
          </ButtonsW>
        </FormW>
      </Form>
    </>
  );
}
